<div class="content">
  <div class="row" *ngIf="!loading">
    <div class="col-md-6"><img  src="assets/emailconfirmado.jpg" alt="Image" class="img-fluid"></div>
    <div class="col-md-6 contents">

      <h3>E-mail Confirmado com Sucesso - LawServices</h3>
      <p>Seu e-mail foi confirmado com sucesso!</p>
      <p>Agora você pode fazer login e aproveitar todos os benefícios do LawServices.
        Estamos entusiasmados em ajudar você a otimizar a gestão do seu escritório com nosso software completo e acessível.</p>
      <input value="Login" (click)="redirecionamentoSucesso()" class="btn btn-block btn-primary">
    </div>
  </div>
</div>

